export const EMPTY_VALUE = "---";
export const EMPTY_VALUE_PASEL_PASSPORT_RPU = "XXXXXX";
